module.exports = __webpack_public_path__ + "static/village_bn@2x-21011dc0cfa24f51552c8ec06ee15d84.png";